import { helper } from '@ember/component/helper';

/**
 * Ritorna la negazione booleana del parametro
 */
var isNot = helper(([value]) => !value);

export { isNot as default };
//# sourceMappingURL=is-not.js.map
